import request from '@/utils/request'

/**
 * 登录日志
 * @param {*} data
 */
function getLoginLogs(data) {
  return request({
    url: '/loginlog/list',
    method: 'post',
    data
  })
}
/**
 * 用户生命周期日志
 * @param {*} data
 */
function getLifecyclelogs(data) {
  return request({
    url: '/userlifecyclelogs/list',
    method: 'post',
    data
  })
}
/**
 * 用户操作日志
 * @param {*} data
 */
function getOperlog(data) {
  return request({
    url: '/useroperlog/list',
    method: 'post',
    data
  })
}
/**
 * 获取用户生命周期日志类型
 * @param {*} data
 */
function getlogtypes() {
  return request({
    url: '/userlifecyclelogs/getlogtypes',
    method: 'get'
  })
}
export {
  getLoginLogs,
  getLifecyclelogs,
  getOperlog,
  getlogtypes
}
